import {
	AsyncButtonContextMenuItem,
} from "src/components/common/contextMenu/AsyncButtonContextMenuItem.tsx";
import { AavoObjectRef } from "src/api/generated/common/sourceType/aavoObjectRef.ts";
import { faHistory } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { useOpenLegacyView } from "src/components/views/legacy/hooks.ts";

export interface ObjectChangeLogContextMenuButtonProps {
	objectRef: AavoObjectRef;
}

export const ObjectChangeLogContextMenuButton = ({
	objectRef,
}: ObjectChangeLogContextMenuButtonProps) => {
	const openLegacyView = useOpenLegacyView();
	return (
		<AsyncButtonContextMenuItem
			icon={faHistory}
			label={i18n.t("change_log")}
			onClick={async () => {
				openLegacyView("DD6E864593E5311A", {
					_changeLogObjectType: objectRef.objectType,
					_changeLogObjectId: objectRef.objectId,
				});
			}}
		/>
	);
};
